module.exports = __webpack_public_path__ + "img/b3f5959eb01b8b4379285e99bb933eaa.svg";